<p-confirmDialog key="UserMultipleSchools" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="UserMultipleSchoolsConfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="ItemMenu">
	<h4 style="text-align: center">User Assigned to Multiple Schools</h4>

	<!--Menu Bar-->
	<div class="button-body MenuBar">
		<!--Buttons-->
		<div class="flex">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onUserRefresh()">Refresh</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAssignToHomeSchool()">
				Assign to Home School Only
			</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onExport()">Export</button>
		</div>
	</div>

	<!--User Table-->
	<div style="margin-top: 15px">
		<p-table
			#mydt
			[value]="lstUsers"
			[loading]="LoadingUser == true"
			[paginator]="true"
			[(rows)]="userpagerows"
			[(first)]="userpagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedUsers"
			dataKey="UserID"
			(onRowSelect)="onUserRowSelect($event)"
			(onRowUnselect)="onUserRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--INSERT CUSTOM FILTERS HERE-->

					<!--UserName-->
					<th>
						<p-columnFilter type="text" field="UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--StaffID-->
					<th>
						<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--PersonTypeDesc-->
					<th>
						<p-columnFilter field="PersonTypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterPersonTypeDesc
									[ngModel]="value"
									[options]="lstPersonTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SchoolFullName-->
					<th>
						<p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--UserLevelDesc-->
					<th>
						<p-columnFilter field="UserLevelDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterUserLevelDesc
									[ngModel]="value"
									[options]="lstUserLevelDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--ActiveDesc-->
					<th>
						<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterActiveDesc
									[ngModel]="value"
									[options]="lstActiveDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SchoolCount-->
					<th>
						<p-columnFilter type="numeric" field="SchoolCount" matchMode="gte" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="UserName">Username<p-sortIcon field="UserName"></p-sortIcon></th>
					<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="PersonTypeDesc">Staff Type<p-sortIcon field="PersonTypeDesc"></p-sortIcon></th>
					<th pSortableColumn="SchoolFullName">Home School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
					<th pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
					<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
					<th pSortableColumn="SchoolCount"># of Schools<p-sortIcon field="SchoolCount"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-User>
				<tr [pSelectableRow]="User">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="User" [value]="User"></p-tableCheckbox>
					</td>

					<td *ngFor="let col of UserCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ User[col.field] }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="User.UserLevelID == 1 ? 'Orangered' : 'Black'"
					>
						{{ User.UserLevelDesc }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="User.Active == true ? 'Black' : 'Red'">
						{{ User.ActiveDesc }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="User.SchoolCount == 1 ? 'Black' : 'Orangered'"
					>
						{{ User.SchoolCount }}
					</td>
				</tr>
			</ng-template>
		</p-table>

		<!--Error Message-->
		<div class="TopMargin">
			<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
		</div>
	</div>
</div>
